import React from 'react';
import type { BombiixIconProps } from './types';

/** Bombiix Care User Instructions icon. */
const CareUserInstructionsIcon: React.FC<BombiixIconProps> = ({ size = 20, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" {...rest}>
    <g transform="translate(2 2)" stroke="currentColor" strokeWidth="1.5">
      <path d="M3 10.001C3 6.22974 3 4.34412 4.17157 3.17255C5.34315 2.00098 7.22876 2.00098 11 2.00098H13C16.7712 2.00098 18.6569 2.00098 19.8284 3.17255C21 4.34412 21 6.22974 21 10.001V14.001C21 17.7722 21 19.6578 19.8284 20.8294C18.6569 22.001 16.7712 22.001 13 22.001H11C7.22876 22.001 5.34315 22.001 4.17157 20.8294C3 19.6578 3 17.7722 3 14.001V10.001Z" />
      <path d="M16.999 14C16.999 16.7614 14.7604 19 11.999 19C9.2376 19 6.99902 16.7614 6.99902 14C6.99902 11.2386 9.2376 9 11.999 9C14.7604 9 16.999 11.2386 16.999 14Z" />
      <path d="M8.00098 6H16.001" strokeLinecap="round" />
      <path d="M7.23418 14.3615C8.08868 14.7885 9.06745 15.52 10.724 15.8186C13.0859 16.2443 12.8501 14.1696 15.2121 14.5951C15.9323 14.7249 16.4181 14.9442 16.7616 15.1796" strokeLinecap="round" />
    </g>
  </svg>
);

export default CareUserInstructionsIcon;
